<form class="pre-form" #formulari="ngForm">
    <mat-grid-list cols="4" rowHeight="80px">                              
        <div *ngFor="let idiomapre of preinscripcio.idiomes">
            <mat-grid-tile>
                <span class="pre-controls-right">{{idiomapre.idioma.name}}:</span>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">                        
                <mat-radio-group name="{{idiomapre.idioma.name}}" class="pre-controls-left" [(ngModel)]="idiomapre.nivell">
                    <mat-radio-button *ngFor="let nivell of nivells_idioma" [value]="nivell.value" class="pre-options">{{nivell.name}}</mat-radio-button>
                </mat-radio-group>           
            </mat-grid-tile>            
        </div>
        <mat-grid-tile [colspan]="4">        
            <mat-checkbox name="swAssabentatIdioma" [(ngModel)]="preinscripcio.swAssabentatIdioma" i18n="@@SwAssabentatIdioma">Declaro que estic assabentat/da de la llengua o les llengües d’impartició de l’estudi al qual vull accedir i al mateix temps renuncio a presentar cap mena de reclamació ni exigència en relació a la llengua o les llengües que s’imparteixi la docència de l’estudi.</mat-checkbox>                              
        </mat-grid-tile>                                                        
        <mat-grid-tile colspan="4" *ngIf="preinscripcio.potModificar">
            <div class="pre-controls-right">
                <button mat-raised-button matStepperPrevious i18n>Torna</button>
                <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button>            
            </div>
        </mat-grid-tile>              
    </mat-grid-list>
</form>


// WEBPACK FOOTER //
// ./src/app/idiomes/idiomes.component.html